import React, { Component } from 'react';
import './styles.scss';

class HeightDownAnimation extends Component {
	render() {
		const { show, height, children } = this.props;
		return (
			<div
				className="HeightDownAnimation"
				style={{
					height: show ? height : 0,
					opacity: show ? 1 : 0,
					overflow: show ? 'visible' : 'hidden'
				}}
			>
				{children}
			</div>
		);
	}
}

export default HeightDownAnimation;
